import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=1be53dfc&scoped=true&"
import script from "./VideoDialog.vue?vue&type=script&lang=ts&"
export * from "./VideoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VideoDialog.vue?vue&type=style&index=0&id=1be53dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be53dfc",
  null
  
)

export default component.exports